const colors = {
  // ----- PRIMARY (GREEN) -----
  primary: {
    100: "#00521D",
    200: "#006122",
    300: "#006B25",
    400: "#007A2B",
    500: "#008A30",
    600: "#009434",
    700: "#189A2E",
    800: "#2FA73D",
    900: "#49AF46",
    main: "rgb(24, 154, 46)",
    light: "#49AF46",
    dark: "#006B25",
    contrastText: "#FFFFFF",
    disabled: "hsl(130, 25%, 60%)",
    opacity: "rgba(24, 154, 46, 0.08)",
  },

  // ----- SECONDARY (ORANGE) -----
  secondary: {
    100: "#9E3500",
    200: "#B84600",
    300: "#CC5200",
    400: "#E56F00",
    500: "#FF8000",
    600: "#FF8C1A",
    700: "#FF962E",
    800: "#FFA347",
    900: "#FFAD5C",
    main: "rgb(255, 128, 0)",
    light: "#FFA347",
    dark: "#CC5200",
    contrastText: "#FFFFFF",
    opacity: "rgba(255, 128, 0, 0.08)",
  },

  // ----- GRAY SCALE -----
  gray: {
    100: "#1A1A1A",
    200: "#333333",
    300: "#4D4D4D",
    400: "#666666",
    500: "#808080",
    600: "#999999",
    700: "#B3B3B3",
    800: "#CCCCCC",
    900: "#E6E6E6",
    main: "#808080",
  },

  // ----- SURFACES (dark) -----
  background: {
    default: "hsl(203, 28%, 9%)", // canvas – fondo principal
    base: "hsl(205, 18%, 13%)", // superficie base
    paper: "hsl(205, 16%, 16%)", // cards / modals
    skeleton: "hsl(205, 16%, 22%)",
  },

  // ----- TEXT -----
  text: {
    primary: "hsl(0, 0%, 95%)",
    secondary: "hsl(0, 0%, 70%)",
    muted: "hsl(0, 0%, 55%)",
  },

  // ----- BORDER -----
  border: {
    default: "hsl(205, 12%, 24%)",
    divider: "hsl(205, 12%, 18%)",
  },

  // ----- INPUTS -----
  input: {
    background: "hsl(205, 16%, 16%)",
    text: "hsl(0, 0%, 95%)",
    placeholder: "hsl(0, 0%, 60%)",
    border: "hsl(205, 12%, 24%)",
    borderFocus: "#2FA73D",
    borderError: "#FF4D4D",
    borderDisabled: "hsl(205, 10%, 20%)",
  },

  highlight: "hsl(0, 0%, 60%)",

  common: {
    black: "#000000",
    white: "#FFFFFF",
  },

  // ----- FEEDBACK / STATES -----
  success: "#2FA73D",
  error: "#FF4D4D",
  warning: "rgb(255, 128, 0)",
  info: "#2196F3",

  // ----- EXTRA -----
  extra: {
    premiumStar: "#ff8000",
    favoriteHeart: "#E31B23",
    tealDark: "#0F4D5C",
    tealGreen: "#157A6E",
  },

  mode: "dark",
};

export default colors;
